import { Component, OnInit } from '@angular/core';
import { TelecomService } from 'src/app/services/telecom/telecom.service';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-quickConnect-report',
  templateUrl: './quickConnect-report.component.html',
  styleUrls: ['./quickConnect-report.component.css']
})
export class quickConnectReportComponent implements OnInit {
  data: Array<any> = [];

  constructor(private telecomService: TelecomService) { }

  ngOnInit(): void {
    //Get the data from the lambda
    let payload = {};
    console.log(payload);
    let params = {
      FunctionName: environment.quickConnectLambdaName,
      Payload: JSON.stringify(payload)
    }
    this.telecomService.callLambda(params, "Failed to get Quick Connect Data").then((data: any) => {
      console.log("The data:")
      console.log(data);
      if(data.statusCode == 200){
        this.data = JSON.parse(data.body);
        console.log(this.data);
      }
      else{
        // this.lambdaError = true;
        // this.lambdaMessage = data.Error.message;
        console.log("Error: ", data.Error)
      }
    });
  }

  buildCSV(){
    //create csv
    let csvContent = "data:text/csv;charset=utf-8,";
    // let keySet = new Set<string>();
    // this.data.forEach((row) => { Object.keys(row).forEach((key) => {keySet.add(key)})});
    // let keys = Array.from(keySet.values());

    // keys must be ordered, so hard code them
    let keys = ["Name", "QuickConnectType", "QueueName", "ContactFlowName",	"Username",	"PhoneNumber",	"Description", "QuickConnectId","QuickConnectARN", "Tags", ]
    // console.log(keys);
    csvContent += keys.join(',') + "\r\n";
    this.data.forEach(rowObject => {
      let rowArray = []
      keys.forEach( key => {
        let rowItem = JSON.stringify(rowObject[key]);
        if(!rowItem){
          rowItem = "";
        }
        rowItem = rowItem.replace(/,/g, '|');
        rowArray.push(rowItem);
      });
      csvContent += rowArray.join(',') + "\r\n";
    });
    // console.log("csvContent: ", csvContent);

    //download
    let encodedUri = encodeURI(csvContent);
    let link = document.getElementById("downloadLink");
    link.setAttribute("href", encodedUri);
    link.setAttribute("download", "QuickConnectData.csv");
    link.click();
  }

}
